export class TdIssuesModel {
  errorMessage:any;
  subject:string;
  name:string;
  message:string;
  emailFrom:string;
  extraData:any;

  constructor(errorMessage:any, subject?:string, name?:string, message?:string, emailFrom?:string, extraData?:any) {
    this.errorMessage = errorMessage;
    this.subject = subject;
    this.name = name;
    this.message = message;
    this.emailFrom = emailFrom;
    this.extraData = extraData;
  }
}



// WEBPACK FOOTER //
// ./admin/src/app/components/td-issues/td-issues.model.ts